"use client";
import { Button } from "@/components/ui/Button";
import { AlertTriangle } from "lucide-react";
import Link from "next/link";

export default function ErrorComponent() {
  return (
    <div className="relative flex h-screen w-full items-center justify-center bg-comp-surface">
      <div className="flex flex-col items-center justify-center gap-4">
        <AlertTriangle className="h-6 w-6 text-comp-text-tertiary" />

        <div className="flex flex-col items-center justify-center gap-1">
          <h2 className="text-lg font-medium text-foreground">
            Something went wrong!
          </h2>
          <p className="text-sm text-comp-text-tertiary">
            We apologize for the inconvenience. Please try again.
          </p>
        </div>
        <div className="flex flex-row gap-2">
          <Button asChild variant="outline" size="sm">
            <Link href="/contact">Support</Link>
          </Button>
          <Button variant="solid" size="sm" onClick={() => window.location.reload()}>
            Retry
          </Button>
        </div>
      </div>
    </div>
  );
}
